// useResendOtpMutation.ts
import { useMutation } from '@tanstack/react-query';
import { resendOtpApi } from '../auth/auth.api';
import { QUERY_KEYS } from '../querykeys';

export const useResendOtpMutation = () => {
  return useMutation({
    mutationKey: [QUERY_KEYS.RESEND_OTP],
    mutationFn: resendOtpApi,
  });
};